import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { Page } from "src/app/model/Page";
import { DocumentVerificationModel } from "src/app/model/DocumentVerificationModel";
import { PaymentReconciliationService } from "src/app/services/payment-reconciliation.service";
import { MasterService } from "src/app/services/master.service";
import { DocumentVerificationService } from "src/app/services/document-verification.service";

@Component({
  selector: "app-secure-document-verificationAllotment",
  templateUrl: "./engineringdocument-verification.component.html",
  styleUrls: ["./document-verification.component.scss"],
})
export class EngineeringDocumentVerificationComponent implements OnInit {
  lotteryList: DocumentVerificationModel[] = [];
  loaded: boolean = false;
  isloaded: boolean = false;
  statusList: any[] = [
    { name: "PENDING", value: "PENDING" },
    { name: "POSSESSION COMPLETE", value: "POSSESION_COMPLETE" },
  //  { name: "INELIGBLE FOR POL", value: "INELIGBLE_FOR_POL" },
  ];
  selectedLotteryCode: string | null = null;
  page: Page<DocumentVerificationModel>;
  dataSource: MatTableDataSource<DocumentVerificationModel> =
    new MatTableDataSource();
  // form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  lotteryEventId: number;
  statusId: string;
  applicationNumber: string;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    // "transactionId",
    "applicantName",
    "schemaCode",
    "paymentStatus",
    // "transactionStatus",
    // "transactionDate",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private _snackBar: MatSnackBar,

    private route: ActivatedRoute,

    private documentVerificationService: DocumentVerificationService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.documentVerificationService.getSchemeName().subscribe(
        (data: any) => {
          this.loaded = true;

          if (data.status === "SUCCESS") {
            this.lotteryList = data.lotteryList;
            console.log("data.lotteryName", this.lotteryList);
          } else {
            this.documentVerificationService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.documentVerificationService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );
    });

    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-payment-settlement-filterText"),
        [Validators.required, Validators.minLength(3)]
      ),
      
    });
    this.filterForm.controls["filterText"].setValue(null);
  }
  onLotteryChange(value: any) {
    this.lotteryEventId = value.key;

    console.log(" this.lotteryEventId:", this.lotteryEventId);
    this.loadData();
  }
  loadData() {
    this.loaded = false;
    if (this.lotteryEventId !== null) {
      this.documentVerificationService
        .getEngineerDocumentVerificationConfirmedList(
          this.lotteryEventId,
          this.statusId,
          this.currentPage,
          this.pageSize,
          this.filterForm.value.filterText
        )
        .subscribe(
          (page: any) => {
            this.loaded = true;
            console.log("Page ", page);
            this.page = page;
            console.log(
              "page.content.applicationNo ",
              page.content.applicationNo
            );
            // if (
            //   page.content.applicationNo !== null &&
            //   page.content.applicationNo !== ""
            // ) {
            if (page.content[0] !== null) {
              this.dataSource = new MatTableDataSource(page.content);
            } else {
              this.dataSource = new MatTableDataSource<DocumentVerificationModel>(
                []
              );
            }
            console.log("this.dataSource ", this.page);
            // } else {
            //   this.loaded = false;
            //   this.paymentSettlementService.errorToast(page.errorMessage);
            // }
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = page.totalElements;
            });
            this.isSearchDisabled = false;
          },
          (error) => {
            console.log(error);
            this.isSearchDisabled = false;
          }
        );
    } else {
      this.documentVerificationService.errorToast("Please select Lottery");
    }
  }

  onStatusChange(value: any) {
    this.statusId = value;
    this.loaded = false;
    this.loadData();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.page = null;
    this.dataSource = new MatTableDataSource();
    this.currentPage = 0;
    this.paginator.pageIndex = this.currentPage;
    this.paginator.length = 0;
  }
  onSearch() {
    if (this.filterForm.valid) {
      this.page = null;
      this.applicationNumber = this.filterForm.value.filterText;
      this.dataSource = null;
      this.pageSize = 0;
      this.currentPage = 0;
      localStorage.setItem(
        "app-secure-payment-settlement-filterText",
        this.filterForm.value.filterText
      );

      this.onLoad();
    } else {
      this._snackBar.open(
        "Application Number is Required ",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }
  onLoad() {
    this.loaded = false;
    console.log(
      "this.filterForm.value.filterText",
      this.filterForm.value.filterText
    );

    this.documentVerificationService
      // .fetchPaymentSettlementList(
      //   this.currentPage,
      //   this.pageSize,
      //   this.filterForm.value.filterText
      // )
      .fetchFilterList(
        
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page: any) => {
          this.page = page;

          if (page.content && page.content.length !== 0) {
            this.dataSource = new MatTableDataSource(page.content);
          } else {
            this._snackBar.open(
              "Please Enter Valid Application Number ",
              "Close",
              {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "warning-toast",
                duration: 3 * 1000,
              }
            );
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
          this.loaded = true;
          this.isloaded = true;
        },
        (error) => {
          console.log(error);
          this.loaded = false;
          this.isSearchDisabled = false;
        }
      );
  }

  // ngAfterViewInit(): void {
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.paginator = this.paginator;
  // }

  pageChanged(event: PageEvent) {
    console.log({ event });
    console.log(event.pageSize);
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
}
